import { Editor } from 'tinymce';

// Add custom charcount functionality
// since default wordcount/ charcount does not follow design requirements
export const charcount = (editor: Editor) => {
  // Since comment content is inside a p tag, there is no 'onchange' event
  // we handle the text changes using 'onkeyup' event
  editor.on('keyup', () => {
    const commentLength = editor
      .getContent()
      .replace(/(<([^>]+)>)/gi, '') // remove the tags from the content to get just the text
      .replace(/(\n)/g, 'n').length; // replace new line with a single random element, so it is included on the count

    const countElement = document.querySelector(
      `.js-character-count-${editor.id}`,
    );
    const modalButton = document.querySelector(`.js-modal-button-${editor.id}`);
    const maxChars = 1000;

    // Comment length is less/equal to 0 or more than maxChars, disable button
    if (commentLength <= 0 || commentLength > maxChars) {
      modalButton?.classList.add('bo-btn--disabled');
    } else {
      modalButton?.classList.remove('bo-btn--disabled');
    }

    const charCountFeedbackMessage = document.querySelector(
      `.js-message-charcount-${editor.id}`,
    );

    // If comment length is more than maxChars add feedback message
    if (commentLength <= maxChars) {
      if (charCountFeedbackMessage)
        (charCountFeedbackMessage as HTMLElement).style.display = 'none';

      countElement?.classList.remove('bc-comments__feedback--error');
    } else {
      if (charCountFeedbackMessage)
        (charCountFeedbackMessage as HTMLElement).style.display = 'block';

      countElement?.classList.add('bc-comments__feedback--error');
    }

    // Display comment length on the element
    if (countElement)
      (countElement as HTMLElement).innerHTML = `${commentLength}`;
  });
};
